/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {AdnHttpService} from '../../../util/adn-http.service';
import {transformJsonProperty} from '../../../util/adn-http-resource-transforms';
import {createAdnHttpResource, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

/** Angular DI token for the ReportSchedule HTTP resource (factory product). */
export class ReportScheduleResource {
}

export function createReportScheduleResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  const ReportSchedule: any = createAdnHttpResource(
    createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler),
    'reportschedules',
    () => localUserProfile,
    'reportSchedules',
    undefined,
    transformJsonProperty('template')
  );
  ReportSchedule.create = function(defaults: any): any {
    return new ReportSchedule(_.assign({recurrence: 'DAILY'}, defaults));
  };
  return ReportSchedule;
}

export const reportScheduleResourceProvider = {
  provide: ReportScheduleResource,
  useFactory: createReportScheduleResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};

